import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import *as firebase from 'firebase';

@Injectable()
export class UserServiceProvider {

  constructor(public http: HttpClient) {
    console.log('Hello UserServiceProvider Provider');
  }

  getloggedinuserdetail(type,uid){
    return new Observable(observer=>{
        firebase.database().ref(type+'/'+uid).on('value',snapshot=>{
            observer.next(snapshot.val());
        })
    })
  }

  getrider(uid){
    return new Observable(observer=>{
      firebase.database().ref('users'+'/'+uid).on('value',snapshot=>{
          observer.next(snapshot.val());
      })
    })
  }

  getdriver(uid){
    return new Observable(observer=>{
      firebase.database().ref('driver'+'/'+uid).on('value',snapshot=>{
          observer.next(snapshot.val());
      })
    })
  }
}